function initialState () {
  // const defaultLocale = 'en-US'
  const defaultLocale = navigator.language

  const {
    decimalSeparator,
    thousandSeparator,
    dateFormat,
    currencyPosition
  } = resolveLocaleConfiguration(defaultLocale)

  return {
    locale: defaultLocale,
    date_format: dateFormat,
    decimal_separator: decimalSeparator,
    thousand_separator: thousandSeparator,
    currency_position: currencyPosition,
    currency: 'EUR',
    currency_symbol: '€'
  }
}

export default {
  namespaced: true,

  state: initialState,

  mutations: {
    reset (state) {
      const initial = initialState()

      Object.keys(initial).forEach(key => state[key] = initial[key])
    },

    setLocale (state, locale) {
      state.locale = locale
    },

    setLocaleConfigurations (state, options) {
      state.date_format = options.dateFormat
      state.decimal_separator = options.decimalSeparator
      state.thousand_separator = options.thousandSeparator
      state.currency_position = options.currencyPosition
    },

    setCurrency (state, currency) {
      state.currency = currency
    }
  },

  actions: {
    reset ({ commit }) {
      commit('reset')
    },

    setLocale ({ commit }, locale) {
      const localeConfiguration = resolveLocaleConfiguration(locale)

      commit('setLocale', locale)
      commit('setLocaleConfigurations', localeConfiguration)
    },

    setCurrency ({ commit }, currency) {
      commit('setCurrency', currency)
    }
  }
}

const resolveLocaleConfiguration = locale => {
  const decimalSeparator = resolveDecimalSeparator(locale)
  const thousandSeparator = resolveThousandSeparator(decimalSeparator)
  const dateFormat = resolveDateFormat(locale)
  const currencyPosition = resolveCurrencyPosition(locale)

  return {
    decimalSeparator,
    thousandSeparator,
    dateFormat,
    currencyPosition
  }
}

const resolveDecimalSeparator = locale => {
  return new Intl.NumberFormat(locale).format(0.1).substring(1, 2)
}

const resolveThousandSeparator = decimalSeparator => {
  return decimalSeparator === ',' ? '.' : ','
}

const resolveCurrencyPosition = locale => {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD'
  })

  const parts = formatter.formatToParts(1.00)

  return parts[0].type === 'currency' ? 'before' : 'after'
}

const resolveDateFormat = locale => {
  const parts = new Intl.DateTimeFormat(locale)
    .formatToParts(new Date('2000/01/01'))

  const separator = parts.find(part => part.type === 'literal').value

  return parts
    .filter(part => part.type !== 'literal')
    .map(part => part.type)
    .join(separator)
    .replace('day', 'DD')
    .replace('month', 'MM')
    .replace('year', 'yyyy')
}
